export default __webpack_public_path__ + "static/media/header.2bcef6ab.png";